module.exports = __webpack_public_path__ + "img/사회활동참여_old.0d42ac42.png";